export const EEG_UPLOAD_HEADER_BYTES = 512;

export type EegUploadHeaderIdentity = {
  headerSha256: string;
  sizeBytes: number;
};

function toHex(buffer: ArrayBuffer): string {
  return Array.from(new Uint8Array(buffer))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
}

export async function sha256Hex(data: ArrayBuffer): Promise<string> {
  const digest = await crypto.subtle.digest("SHA-256", data);
  return toHex(digest);
}

async function readBlobPrefix(file: Blob, byteCount: number): Promise<ArrayBuffer> {
  const prefix = file.slice(0, byteCount) as Blob;
  if (typeof prefix.arrayBuffer === "function") {
    return prefix.arrayBuffer();
  }
  throw new Error("EEG header hashing requires Blob.arrayBuffer support");
}

export async function hashEegUploadHeader(
  file: Blob,
): Promise<EegUploadHeaderIdentity> {
  const headerSha256 = await sha256Hex(await readBlobPrefix(file, EEG_UPLOAD_HEADER_BYTES));
  return { headerSha256, sizeBytes: file.size };
}

export function shouldSkipEegChunkUpload(init: {
  reused?: boolean;
  staged_upload_id?: string;
  totalChunks?: number;
}): boolean {
  return Boolean(init.reused && init.staged_upload_id) || init.totalChunks === 0;
}
